/* Generated by npm run build:perf-debug — edit scripts/perf-debug/*.js */
(() => {
const STORAGE_KEY = "themePerfDebug";
const FOCUS_STORAGE_KEY = "themePerfDebugFocus";

/** Edit defaults here, or pass ?perfdebug=cls,network (summary always prints). */
const SECTION_DEFAULTS = {
  lcp: false,
  cls: true,
  clsDetailed: true,
  headingFonts: true,
  longTasks: false,
  network: false,
  jsonExport: true,
};

const SECTION_ALIASES = {
  cls: "cls",
  "cls-detailed": "clsDetailed",
  clsdetailed: "clsDetailed",
  detailed: "clsDetailed",
  fonts: "headingFonts",
  "heading-fonts": "headingFonts",
  judgeme: "__judgeme_preset__",
  jm: "__judgeme_preset__",
  jdgm: "__judgeme_preset__",
  lcp: "lcp",
  network: "network",
  resources: "network",
  longtasks: "longTasks",
  "long-tasks": "longTasks",
  json: "jsonExport",
  export: "jsonExport",
};

const JUDGEME_PRESET = ["cls", "clsDetailed", "headingFonts", "jsonExport"];

const parseFocusList = (raw) => {
  if (!raw || raw === "1" || raw === "true") return null;
  const parts = raw
    .split(",")
    .map((part) => part.trim().toLowerCase())
    .filter(Boolean);

  if (parts.some((part) => part === "__judgeme_preset__" || ["judgeme", "jm", "jdgm"].includes(part))) {
    return [...JUDGEME_PRESET];
  }

  const keys = parts
    .map((part) => SECTION_ALIASES[part] || part)
    .filter((key) => key in SECTION_DEFAULTS);

  return keys.length ? keys : null;
};

const resolveSections = () => {
  const params = new URLSearchParams(window.location.search);
  const fromUrl = parseFocusList(params.get("perfdebug"));
  let fromStorage = null;

  try {
    fromStorage = parseFocusList(window.localStorage.getItem(FOCUS_STORAGE_KEY));
  } catch {}

  const focus = fromUrl || fromStorage;
  if (!focus) return { ...SECTION_DEFAULTS };

  const sections = Object.fromEntries(
    Object.keys(SECTION_DEFAULTS).map((key) => [key, focus.includes(key)])
  );

  return sections;
};

const isEnabled = () => {
  const params = new URLSearchParams(window.location.search);
  if (params.has("perfdebug")) return true;

  try {
    return window.localStorage.getItem(STORAGE_KEY) === "1";
  } catch {
    return false;
  }
};

window.__enableThemePerfDebug = (focus) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, "1");
    if (focus) {
      window.localStorage.setItem(FOCUS_STORAGE_KEY, focus);
    }
  } catch {}
  window.location.reload();
};

window.__disableThemePerfDebug = () => {
  try {
    window.localStorage.removeItem(STORAGE_KEY);
    window.localStorage.removeItem(FOCUS_STORAGE_KEY);
  } catch {}
  window.location.reload();
};

window.__setThemePerfDebugFocus = (focus) => {
  try {
    if (!focus || focus === "all") {
      window.localStorage.removeItem(FOCUS_STORAGE_KEY);
    } else {
      const value = Array.isArray(focus) ? focus.join(",") : focus;
      window.localStorage.setItem(FOCUS_STORAGE_KEY, value);
    }
  } catch {}
  window.location.reload();
};

if (!isEnabled()) return;

const SECTIONS = resolveSections();

const JUDGEME_FOCUS = (() => {
  const params = new URLSearchParams(window.location.search);
  let stored = "";

  try {
    stored = window.localStorage.getItem(FOCUS_STORAGE_KEY) || "";
  } catch {}

  const raw = [params.get("perfdebug"), stored].filter(Boolean).join(",");
  return /(?:^|,)(judgeme|jm|jdgm)(?:,|$)/i.test(raw);
})();

console.log("[perfdebug] boot", { sections: SECTIONS, judgeMeFocus: JUDGEME_FOCUS });

const OBSERVER_WINDOW_MS = 20000;

const state = {
  nav: null,
  paints: {},
  lcp: null,
  cls: 0,
  clsShifts: [],
  longTasks: [],
  resources: [],
  layoutMarks: [],
  headingFontChanges: [],
  fontEvents: [],
  reportPrinted: false,
};

const observers = [];

const round = (value) => (typeof value === "number" ? Math.round(value * 100) / 100 : value);

/** Judge.me widgets and nearby card slots — primary CLS suspects on collection pages. */
const judgemeTrackedSelectors = [
  ".card-information__reviews",
  ".jdgm-widget.jdgm-preview-badge",
  ".jdgm-preview-badge",
  ".jdgm-prev-badge",
  ".jdgm-prev-badge__stars",
  ".jdgm-prev-badge__text",
  ".jdgm-widget.jdgm-carousel",
  ".jdgm-carousel-wrapper",
  ".jdgm-carousel",
  ".jdgm-carousel-item",
  ".jdgm-featured-carousel",
  ".jdgm-rev-widg",
  ".hadat-reviews-summary",
  '[id*="featured_carousel"]',
  '[id*="__1717704614cb53687c"]',
];

/** Minimal grid anchors to see how Judge.me shifts move the product grid. */
const contextTrackedSelectors = [
  "#main-collection-filters",
  ".facets-wrapper",
  "#ProductGridContainer",
  "#product-grid",
];

const generalTrackedSelectors = [
  "[data-widget-builder-banner-ssr-slot='top']",
  ".widget-builder-banner--top",
  "#shopify-section-header",
  "#MainContent",
  ".collection-list-wrapper",
  "product-info",
  ".product",
  ".product__media-wrapper",
  ".product__info-wrapper",
];

const trackedSelectors = JUDGEME_FOCUS
  ? [...judgemeTrackedSelectors, ...contextTrackedSelectors]
  : [...judgemeTrackedSelectors, ...contextTrackedSelectors, ...generalTrackedSelectors];

const MAX_LAYOUT_MARKS = 60;
const MUTATION_MARK_DEBOUNCE_MS = 150;
let mutationMarkTimer = null;

const isJudgeMeNode = (element) => {
  if (!element || element.nodeType !== 1) return false;

  try {
    if (element.classList?.contains("jdgm-widget")) return true;
    if (element.closest?.(".jdgm-widget")) return true;

    const className = String(element.className || "");
    if (className.split(/\s+/).some((name) => name.startsWith("jdgm-"))) return true;

    if (element.closest?.(".card-information__reviews")) return true;
  } catch {}

  return false;
};

const getJudgeMeWidgetType = (element) => {
  if (!element) return null;

  try {
    const root = element.classList?.contains("jdgm-widget")
      ? element
      : element.closest?.(".jdgm-widget");

    if (!root) {
      if (element.closest?.(".card-information__reviews")) return "preview_badge_slot";
      return null;
    }

    const named = root.getAttribute("data-widget-name");
    if (named) return named;

    if (root.classList.contains("jdgm-preview-badge")) return "preview_badge";
    if (root.classList.contains("jdgm-carousel")) return "featured_carousel";
    if (root.classList.contains("jdgm-all-reviews-text")) return "all_reviews_text";
    if (root.classList.contains("jdgm-rev-widg")) return "review_widget";

    return "judgeme_widget";
  } catch {
    return null;
  }
};

const getElementSelector = (element) => {
  if (!element || element.nodeType !== 1) return "";

  try {
    if (element.id) return "#" + element.id;

    const parts = [];
    let current = element;
    let depth = 0;

    while (current && current.nodeType === 1 && depth < 4) {
      let part = current.tagName.toLowerCase();
      if (current.id) {
        parts.unshift("#" + current.id);
        break;
      }

      const className = [...(current.classList || [])]
        .filter((name) => name.startsWith("jdgm-") || name === "card-information__reviews")
        .slice(0, 2)
        .join(".");

      if (className) part += "." + className;
      parts.unshift(part);
      current = current.parentElement;
      depth += 1;
    }

    return parts.join(" > ");
  } catch {
    return element.tagName?.toLowerCase() || "";
  }
};

const describeShiftSource = (source) => {
  const node = source.node;
  const widget = getJudgeMeWidgetType(node);
  const previousRect = source.previousRect;
  const currentRect = source.currentRect;

  return {
    isJudgeMe: Boolean(widget),
    widget,
    selector: getElementSelector(node),
    productId: node?.closest?.(".jdgm-preview-badge")?.getAttribute("data-id") || null,
    deltaY: previousRect && currentRect ? round(currentRect.y - previousRect.y) : null,
    deltaHeight:
      previousRect && currentRect ? round(currentRect.height - previousRect.height) : null,
    previousRect,
    currentRect,
    node: node?.outerHTML?.slice(0, 300) || null,
  };
};

const getSelectorLabel = (element) => {
  if (!element) return "";
  if (element.id) return "#" + element.id;
  for (const selector of trackedSelectors) {
    try {
      if (element.matches && element.matches(selector)) return selector;
    } catch {}
  }
  return getElementSelector(element) || element.tagName?.toLowerCase() || "";
};

const captureLayoutMark = (reason, detail) => {
  const time = round(performance.now());
  const marks = trackedSelectors.flatMap((selector) => {
    try {
      return [...document.querySelectorAll(selector)].slice(0, 6).map((element) => {
        const rect = element.getBoundingClientRect();
        return {
          selector,
          label: getSelectorLabel(element),
          widget: getJudgeMeWidgetType(element),
          top: round(rect.top),
          bottom: round(rect.bottom),
          height: round(rect.height),
          width: round(rect.width),
        };
      });
    } catch {
      return [];
    }
  });

  if (!marks.length) return;

  state.layoutMarks.push({ reason, time, detail: detail || null, marks });
  if (state.layoutMarks.length > MAX_LAYOUT_MARKS) {
    state.layoutMarks = state.layoutMarks.slice(-MAX_LAYOUT_MARKS);
  }
};

const HEADING_FONT_SELECTORS = [
  ".product-card-wrapper .card__heading",
  ".product-card-wrapper .card__heading a",
  ".collection-card-wrapper .card__heading",
  ".collection-card-wrapper .card__heading a",
];

const MAX_HEADING_FONT_CHANGES = 80;
const headingFontSamples = new WeakMap();

const readFontMetrics = (element) => {
  if (!element || element.nodeType !== 1) return null;

  try {
    const style = getComputedStyle(element);
    const rect = element.getBoundingClientRect();
    const lineHeight = parseFloat(style.lineHeight) || 0;

    return {
      fontFamily: style.fontFamily,
      fontSize: style.fontSize,
      fontWeight: style.fontWeight,
      lineHeight: style.lineHeight,
      letterSpacing: style.letterSpacing,
      height: round(rect.height),
      width: round(rect.width),
      lines: lineHeight > 0 ? Math.round(rect.height / lineHeight) : null,
      webFontReady: document.fonts?.check?.(
        `${style.fontWeight} ${style.fontSize} ${style.fontFamily.split(",")[0].replace(/['"]/g, "").trim()}`
      ),
    };
  } catch {
    return null;
  }
};

const getHeadingLabel = (element, selector) => {
  if (element.id) return "#" + element.id;
  const text = element.textContent?.trim().slice(0, 48);
  return text ? selector + " :: " + text : selector;
};

const recordFontEvent = (eventName, detail) => {
  state.fontEvents.push({
    time: round(performance.now()),
    event: eventName,
    ...detail,
  });
  if (state.fontEvents.length > 40) {
    state.fontEvents = state.fontEvents.slice(-40);
  }
};

const sampleHeadingFonts = (reason) => {
  const time = round(performance.now());
  const bodyClasses = document.body.className;

  for (const selector of HEADING_FONT_SELECTORS) {
    let elements = [];

    try {
      elements = [...document.querySelectorAll(selector)].slice(0, 10);
    } catch {
      continue;
    }

    for (const element of elements) {
      const metrics = readFontMetrics(element);
      if (!metrics) continue;

      const previous = headingFontSamples.get(element);
      if (previous && JSON.stringify(previous.metrics) !== JSON.stringify(metrics)) {
        state.headingFontChanges.push({
          time,
          reason,
          selector,
          label: getHeadingLabel(element, selector),
          text: element.textContent?.trim().slice(0, 80) || "",
          before: previous.metrics,
          after: metrics,
          bodyClasses,
          judgeMeBodyClass: /\bjdgm--/.test(bodyClasses),
        });

        if (state.headingFontChanges.length > MAX_HEADING_FONT_CHANGES) {
          state.headingFontChanges = state.headingFontChanges.slice(-MAX_HEADING_FONT_CHANGES);
        }
      }

      headingFontSamples.set(element, { time, metrics });
    }
  }
};

const summarizeJudgeMeShift = (shift) => {
  const sources = shift.sources || [];
  const judgeMeSources = sources.filter((source) => source.isJudgeMe);
  const widgets = [...new Set(judgeMeSources.map((source) => source.widget).filter(Boolean))];

  return {
    value: shift.value,
    startTime: shift.startTime,
    judgeMeSources: judgeMeSources.length,
    totalSources: sources.length,
    widgets: widgets.join(", ") || "(none tagged)",
    primarySelector: judgeMeSources[0]?.selector || sources[0]?.selector || "",
    primaryDeltaY: judgeMeSources[0]?.deltaY ?? sources[0]?.deltaY ?? null,
  };
};

try {
  const paintObserver = new PerformanceObserver((list) => {
    for (const entry of list.getEntries()) {
      state.paints[entry.name] = entry.startTime;
    }
  });
  paintObserver.observe({ type: "paint", buffered: true });
  observers.push(paintObserver);
} catch {}

try {
  const lcpObserver = new PerformanceObserver((list) => {
    const entries = list.getEntries();
    state.lcp = entries[entries.length - 1] || state.lcp;
  });
  lcpObserver.observe({ type: "largest-contentful-paint", buffered: true });
  observers.push(lcpObserver);
} catch {}

try {
  const clsObserver = new PerformanceObserver((list) => {
    for (const entry of list.getEntries()) {
      if (!entry.hadRecentInput) {
        const sources = (entry.sources || []).map(describeShiftSource);
        const judgeMeSources = sources.filter((source) => source.isJudgeMe);

        state.cls += entry.value;
        state.clsShifts.push({
          value: round(entry.value),
          startTime: round(entry.startTime),
          judgeMeAttributed: judgeMeSources.length > 0,
          sources,
        });

        if (SECTIONS.clsDetailed) {
          const widgets = [...new Set(judgeMeSources.map((source) => source.widget).filter(Boolean))];
          captureLayoutMark("layout-shift:" + round(entry.value), {
            judgeMeAttributed: judgeMeSources.length > 0,
            widgets: widgets.join(", ") || null,
          });
          if (SECTIONS.headingFonts) {
            sampleHeadingFonts("layout-shift:" + round(entry.value));
          }
        }
      }
    }
  });
  clsObserver.observe({ type: "layout-shift", buffered: true });
  observers.push(clsObserver);
} catch {}

if (SECTIONS.clsDetailed) {
  try {
    const mutationObserver = new MutationObserver((mutations) => {
      const judgeMeHits = [];

      for (const mutation of mutations) {
        const nodes = [...mutation.addedNodes, ...mutation.removedNodes].filter(
          (node) => node && node.nodeType === 1
        );

        for (const node of nodes) {
          const element = /** @type {Element} */ (node);
          if (!isJudgeMeNode(element) && !element.querySelector?.(".jdgm-widget, .jdgm-prev-badge, .card-information__reviews")) {
            continue;
          }

          const widget = getJudgeMeWidgetType(element);
          judgeMeHits.push({
            type: mutation.type,
            widget: widget || "judgeme_dom",
            selector: getElementSelector(element),
          });
        }
      }

      if (!judgeMeHits.length) return;
      if (mutationMarkTimer) window.clearTimeout(mutationMarkTimer);
      mutationMarkTimer = window.setTimeout(() => {
        captureLayoutMark("judgeme-mutation", {
          hits: judgeMeHits.slice(0, 8),
        });
      }, MUTATION_MARK_DEBOUNCE_MS);
    });

    mutationObserver.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "style", "hidden"],
    });
    observers.push(mutationObserver);
  } catch {}
}

try {
  const longTaskObserver = new PerformanceObserver((list) => {
    state.longTasks.push(...list.getEntries());
    state.longTasks.sort((a, b) => b.duration - a.duration);
  });
  longTaskObserver.observe({ type: "longtask", buffered: true });
  observers.push(longTaskObserver);
} catch {}

const resourceSummary = () => {
  const resources = performance
    .getEntriesByType("resource")
    .map((entry) => ({
      name: entry.name,
      type: entry.initiatorType || "other",
      duration: round(entry.duration),
      startTime: round(entry.startTime),
      transferSize: entry.transferSize || 0,
      decodedBodySize: entry.decodedBodySize || 0,
      renderBlockingStatus: entry.renderBlockingStatus || "",
    }));

  const byTransfer = [...resources]
    .sort((a, b) => b.transferSize - a.transferSize)
    .slice(0, 10);

  const byDuration = [...resources]
    .sort((a, b) => b.duration - a.duration)
    .slice(0, 10);

  return { resources, byTransfer, byDuration };
};

const buildExport = () => {
  state.nav = performance.getEntriesByType("navigation")[0] || null;
  const { resources, byTransfer, byDuration } = resourceSummary();
  state.resources = resources;

  const payload = {
    url: window.location.href,
    sections: SECTIONS,
    summary: {
      ttfb: round(state.nav?.responseStart),
      domContentLoaded: round(state.nav?.domContentLoadedEventEnd),
      loadEventEnd: round(state.nav?.loadEventEnd),
      fcp: round(state.paints["first-contentful-paint"]),
      lcp: round(state.lcp?.startTime),
      cls: round(state.cls),
      longTaskCount: state.longTasks.length,
      topLongTask: round(state.longTasks[0]?.duration || 0),
      resourceCount: resources.length,
      totalTransferKB: round(resources.reduce((sum, item) => sum + item.transferSize, 0) / 1024),
    },
    lcp: state.lcp
      ? {
          url: state.lcp.url || "",
          startTime: round(state.lcp.startTime),
          size: state.lcp.size || null,
          element: state.lcp.element?.outerHTML?.slice(0, 500) || null,
        }
      : null,
    topResourcesByTransfer: byTransfer.map((entry) => ({
      type: entry.type,
      transferKB: round(entry.transferSize / 1024),
      duration: entry.duration,
      startTime: entry.startTime,
      renderBlockingStatus: entry.renderBlockingStatus,
      name: entry.name,
    })),
    topResourcesByDuration: byDuration.map((entry) => ({
      type: entry.type,
      duration: entry.duration,
      transferKB: round(entry.transferSize / 1024),
      startTime: entry.startTime,
      renderBlockingStatus: entry.renderBlockingStatus,
      name: entry.name,
    })),
    topLongTasks: state.longTasks.slice(0, 10).map((entry) => ({
      startTime: round(entry.startTime),
      duration: round(entry.duration),
      name: entry.name,
    })),
    clsShifts: [...state.clsShifts]
      .sort((a, b) => b.value - a.value)
      .slice(0, 10),
    judgeMeCls: (() => {
      const shifts = state.clsShifts.filter((shift) => shift.judgeMeAttributed);
      const widgets = {};

      for (const shift of shifts) {
        for (const source of shift.sources || []) {
          if (!source.isJudgeMe || !source.widget) continue;
          widgets[source.widget] = round((widgets[source.widget] || 0) + shift.value);
        }
      }

      return {
        shiftCount: shifts.length,
        clsTotal: round(shifts.reduce((sum, shift) => sum + shift.value, 0)),
        byWidget: widgets,
        shifts: shifts.map(summarizeJudgeMeShift),
      };
    })(),
    layoutMarks: state.layoutMarks.slice(-40),
    fontEvents: state.fontEvents.slice(-20),
    headingFontChanges: state.headingFontChanges.slice(-40),
  };

  return payload;
};

const printReport = (force = false) => {
  if (state.reportPrinted && !force) return;
  if (!force) state.reportPrinted = true;
  const payload = buildExport();

  console.group("[perfdebug] summary");
  console.table(payload.summary);
  console.groupEnd();

  if (SECTIONS.lcp && payload.lcp?.element) {
    console.group("[perfdebug] lcp");
    console.log("element", payload.lcp.element);
    console.log("url", payload.lcp.url || "");
    console.log("size", payload.lcp.size || "");
    console.log("startTime", payload.lcp.startTime);
    console.groupEnd();
  }

  if (SECTIONS.longTasks && payload.topLongTasks.length) {
    console.group("[perfdebug] long tasks");
    console.table(payload.topLongTasks);
    console.groupEnd();
  }

  if (SECTIONS.cls && payload.clsShifts.length) {
    console.group("[perfdebug] layout shifts");
    console.table(
      payload.clsShifts.map((shift) => ({
        value: shift.value,
        startTime: shift.startTime,
        judgeMe: shift.judgeMeAttributed ? "yes" : "no",
        widgets:
          [...new Set(shift.sources.filter((source) => source.isJudgeMe).map((source) => source.widget))]
            .filter(Boolean)
            .join(", ") || "",
        source: shift.sources[0]?.selector || shift.sources[0]?.node || "",
      }))
    );
    console.groupEnd();
  }

  if (SECTIONS.cls && payload.judgeMeCls.shiftCount) {
    console.group("[perfdebug] judge.me cls attribution");
    console.log("total attributed cls:", payload.judgeMeCls.clsTotal);
    console.table(payload.judgeMeCls.byWidget);
    console.table(payload.judgeMeCls.shifts);
    console.groupEnd();
  }

  if (SECTIONS.clsDetailed && payload.clsShifts.length) {
    console.group("[perfdebug] layout shift sources (detailed)");
    console.log(payload.clsShifts);
    console.groupEnd();
  }

  if (SECTIONS.clsDetailed && payload.layoutMarks?.length) {
    console.group("[perfdebug] layout marks (judge.me + grid context)");
    console.log(payload.layoutMarks);
    console.groupEnd();
  }

  if (SECTIONS.headingFonts && payload.fontEvents?.length) {
    console.group("[perfdebug] font events");
    console.table(payload.fontEvents);
    console.groupEnd();
  }

  if (SECTIONS.headingFonts && payload.headingFontChanges?.length) {
    console.group("[perfdebug] heading font changes");
    console.table(
      payload.headingFontChanges.map((change) => ({
        time: change.time,
        reason: change.reason,
        label: change.label,
        fontBefore: change.before?.fontFamily,
        fontAfter: change.after?.fontFamily,
        sizeBefore: change.before?.fontSize,
        sizeAfter: change.after?.fontSize,
        linesBefore: change.before?.lines,
        linesAfter: change.after?.lines,
        heightBefore: change.before?.height,
        heightAfter: change.after?.height,
        judgeMeBody: change.judgeMeBodyClass ? "yes" : "no",
      }))
    );
    console.log(payload.headingFontChanges);
    console.groupEnd();
  } else if (SECTIONS.headingFonts) {
    console.log("[perfdebug] heading font changes: none detected in watch window");
  }

  if (SECTIONS.network) {
    console.group("[perfdebug] top resources by transfer");
    console.table(payload.topResourcesByTransfer);
    console.groupEnd();

    console.group("[perfdebug] top resources by duration");
    console.table(payload.topResourcesByDuration);
    console.groupEnd();
  }

  if (SECTIONS.jsonExport) {
    console.log("[perfdebug] paste this JSON:");
    console.log(JSON.stringify(payload, null, 2));
  }

  window.__themePerfDebug = state;
  window.__themePerfDebugExport = payload;
  window.__themePerfDebugSections = SECTIONS;
};

const scheduleReport = () => {
  window.setTimeout(printReport, 0);
};

window.__printThemePerfDebug = () => printReport(true);
window.__getThemePerfDebug = () => {
  const payload = buildExport();
  window.__themePerfDebugExport = payload;
  return payload;
};
window.__getThemePerfDebugExport = window.__getThemePerfDebug;

window.addEventListener("load", scheduleReport, { once: true });
window.setTimeout(scheduleReport, 5000);

window.setTimeout(() => {
  if (mutationMarkTimer) {
    window.clearTimeout(mutationMarkTimer);
    mutationMarkTimer = null;
  }
  observers.forEach((observer) => observer.disconnect());
  printReport(true);
}, OBSERVER_WINDOW_MS);

if (!SECTIONS.headingFonts) return;

const HEADING_FONT_POLL_MS = 400;
let headingFontPollTimer = null;

const startHeadingFontWatch = () => {
  sampleHeadingFonts("initial");

  headingFontPollTimer = window.setInterval(() => {
    sampleHeadingFonts("poll");
  }, HEADING_FONT_POLL_MS);

  window.setTimeout(() => {
    if (headingFontPollTimer) window.clearInterval(headingFontPollTimer);
    sampleHeadingFonts("final");
  }, OBSERVER_WINDOW_MS);
};

try {
  document.fonts?.addEventListener?.("loading", (event) => {
    const families = [...(event.fontfaces || [])].map((face) => face.family);
    recordFontEvent("loading", { families });
    sampleHeadingFonts("document.fonts:loading");
  });
} catch {}

try {
  document.fonts?.addEventListener?.("loadingdone", (event) => {
    const families = [...(event.fontfaces || [])].map((face) => face.family);
    recordFontEvent("loadingdone", { families });
    sampleHeadingFonts("document.fonts:loadingdone");
  });
} catch {}

try {
  document.fonts?.addEventListener?.("loadingerror", (event) => {
    const families = [...(event.fontfaces || [])].map((face) => face.family);
    recordFontEvent("loadingerror", { families });
    sampleHeadingFonts("document.fonts:loadingerror");
  });
} catch {}

try {
  const fontResourceObserver = new PerformanceObserver((list) => {
    for (const entry of list.getEntries()) {
      if (!/font|woff|judgeme|jdgm/i.test(entry.name || "")) continue;
      recordFontEvent("resource", { name: entry.name, startTime: round(entry.startTime) });
      sampleHeadingFonts("font-resource");
    }
  });
  fontResourceObserver.observe({ type: "resource", buffered: true });
  observers.push(fontResourceObserver);
} catch {}

try {
  const headingResizeObserver = new ResizeObserver((entries) => {
    const resized = entries.some((entry) => {
      const element = entry.target;
      return HEADING_FONT_SELECTORS.some((selector) => {
        try {
          return element.matches(selector);
        } catch {
          return false;
        }
      });
    });

    if (!resized) return;
    sampleHeadingFonts("resize");
  });

  const observeHeadings = () => {
    for (const selector of HEADING_FONT_SELECTORS) {
      try {
        for (const element of document.querySelectorAll(selector)) {
          headingResizeObserver.observe(element);
        }
      } catch {}
    }
  };

  observeHeadings();
  observers.push(headingResizeObserver);

  const headingDomObserver = new MutationObserver(() => {
    observeHeadings();
  });
  headingDomObserver.observe(document.documentElement, { childList: true, subtree: true });
  observers.push(headingDomObserver);
} catch {}

try {
  const bodyClassObserver = new MutationObserver((mutations) => {
    const classChanged = mutations.some(
      (mutation) =>
        mutation.type === "attributes" &&
        mutation.attributeName === "class" &&
        mutation.target === document.body
    );

    if (!classChanged) return;
    sampleHeadingFonts("body-class");
  });
  bodyClassObserver.observe(document.body, { attributes: true, attributeFilter: ["class"] });
  observers.push(bodyClassObserver);
} catch {}

try {
  const headingStyleObserver = new MutationObserver((mutations) => {
    const hit = mutations.some((mutation) => {
      if (mutation.type !== "attributes") return false;
      const element = mutation.target;
      return HEADING_FONT_SELECTORS.some((selector) => {
        try {
          return element.matches?.(selector);
        } catch {
          return false;
        }
      });
    });

    if (!hit) return;
    sampleHeadingFonts("heading-attr");
  });

  const observeHeadingAttributes = () => {
    for (const selector of HEADING_FONT_SELECTORS) {
      try {
        for (const element of document.querySelectorAll(selector)) {
          headingStyleObserver.observe(element, {
            attributes: true,
            attributeFilter: ["class", "style"],
          });
        }
      } catch {}
    }
  };

  observeHeadingAttributes();

  const headingAttrDomObserver = new MutationObserver(() => {
    observeHeadingAttributes();
  });
  headingAttrDomObserver.observe(document.documentElement, { childList: true, subtree: true });
  observers.push(headingStyleObserver);
  observers.push(headingAttrDomObserver);
} catch {}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", startHeadingFontWatch, { once: true });
} else {
  startHeadingFontWatch();
}
})();
